/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxGradingMatrixPrintController", function GradingMatrixPrintController(
	$scope,
	dxRubricsRepository,
	$routeParams,
	$window,
	$location,
	DX_URLS
) {
	"use strict";
	var matrixId = parseInt($routeParams.id, 10) || 0;

	$scope.back = function goBack() {
		$window.history.back();
	};

	if (matrixId !== 0) {
		dxRubricsRepository.load(matrixId).then(function handleResponse(matrix) {
			if (!matrix) {
				$location.path(DX_URLS.get(404)).replace();
				return;
			}
			$scope.matrix = matrix;
		});
	}
});
